module.exports = __webpack_public_path__ + "media/images/forms-icons/tabular-icon-hover-07917d4f722851614baf21d9be607e7b.svg";